// Згенеровано Tools/gen_frontend.py з визначень модулів. Не редагувати вручну: зміни моделі — у визначенні модуля
// Solutions/Metadata/<Група>/<Модуль>/module.definition.json (каталог Design — похідний), власні подання — у views/ пакета.

import type { IRecordTypeDefinition } from '@platform/core/types';
import { assembleViewSet } from '@platform/core/lib/assembleViewSet';
import memberRoleEntity from './entities/member-role.json';
import memberRoleMenu from '../pages/member-role/menu.json';
import memberRoleFullForm from '../pages/member-role/forms/full.json';
import memberRoleContextForm from '../pages/member-role/forms/context.json';
import memberRoleMiniForm from '../pages/member-role/forms/mini.json';
import memberRoleLookupForm from '../pages/member-role/forms/lookup.json';
import memberRoleTableView from '../pages/member-role/views/table.json';
import memberRoleCardsView from '../pages/member-role/views/cards.json';
import memberRoleDashboardView from '../pages/member-role/views/dashboard.json';

/** Тип запису «Посада члена» зі сторінками пакета: меню, форми та подання з pages/member-role/. */
export const memberRoleDefinition: IRecordTypeDefinition = {
  ...memberRoleEntity,
  views: assembleViewSet({
      table: memberRoleTableView,
      cards: memberRoleCardsView,
      dashboard: memberRoleDashboardView,
  }),
  form: memberRoleFullForm,
  forms: { full: memberRoleFullForm, context: memberRoleContextForm, mini: memberRoleMiniForm, lookup: memberRoleLookupForm },
  menu: memberRoleMenu,
} as IRecordTypeDefinition;
